<template>
    <div class="card-container">
        <ListHeader title="三级维度指标">
            <template slot="right">
                <ActionButton />
            </template>
        </ListHeader>
        <div class="content">
            <Score />
        </div>
    </div>
</template>
<script>
import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import ActionButton from './ActionButton.vue';
export default {
    name: 'ReportStyle1',
    components: {
        ListHeader,
        Score,
        ActionButton,
    },
    data() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.card-container {
    background: rgba(0, 28, 53, 0.7);
    box-sizing: border-box;
    border: 1px solid;
    border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;

    .content {
        height: 220px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>